function getConfigVar(key: string, required = true): string {
  const val = process.env[key];
  if (val === undefined) {
    if (required) throw new Error(`The variable with name ${key} is not set in .env.`);
    return "";
  }
  return val;
}

export class Config {
  static getBackendUrl(): string {
    if (process.env.NODE_ENV === "development") return "/api";
    // Default to the same-origin relative path (nginx/ingress proxy /api).
    // Never throw here: a hard failure at this call site blanks the whole app.
    return getConfigVar("REACT_APP_BACKEND_URL", false) || "/api";
  }
}
